import React from "react";
import styles from "./NewHero.module.scss";
import { useColorModeValue } from "../../hooks/useColorModeValue";
import lightTitle from "../../assets/hero/gdsc-plane-light.svg";
import darkTitle from "../../assets/hero/gdsc-plane-dark.svg";

const NewHero = () => {
  return (
    <section className={styles["hero"]}>
      <div className={styles["hero-info"]}>
        <div className={styles["gdsc-logo"]}>
          <img
            className={styles["desktop-img"]}
            draggable={false}
            src={useColorModeValue(lightTitle, darkTitle)}
            alt="Google Developer Student Clubs RCOEM, Nagpur"
          />
        </div>
        <div className={styles["heading"]}>
          <h2
            style={{
              color: useColorModeValue("rgba(97, 97, 97, 1)", "rgba(232, 234, 237, 1)"),
            }}
          >
            <p>RCOEM Chapter</p>
          </h2>
          <h3
            style={{
              color: useColorModeValue("rgba(97, 97, 97, 1)", "rgba(232, 234, 237, 1)"),
            }}
          >
            <p>
              Google Developer Student Clubs are community groups for college and university
              students interested in Google developer technologies.
            </p>
          </h3>
        </div>
        <div className={styles["cta-container"]}>
          <div
            style={{ color: useColorModeValue("#202124", "white") }}
            className={styles["date"]}
          ></div>
          <div className={styles["register-cta"]}>
            <a style={{ cursor: "pointer" }} href=" ">
              JOIN US
            </a>
          </div>
        </div>
      </div>

      {/* <div className={styles["hero-map-container"]}>
        {useColorModeValue(
          <MainSvg></MainSvg>,
          <div>
            <MainSvg></MainSvg>
          </div>
        )}
      </div> */}
    </section>
  );
};

export default NewHero;
